import React, { Component } from "react";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { withTranslation } from "react-i18next";

class AcademicResultTable extends Component {
  render() {
    const { acad, gpa, t } = this.props;        
    this.renderHeadingRow = this.renderHeadingRow.bind(this);
    this.renderRow = this.renderRow.bind(this);
    let NumOfSemester = gpa.length;    

    if (NumOfSemester === 0) {
      return <div>{t("Data Not Found")}</div>
    }

    if (NumOfSemester > 1) {
      return (      
        <React.Fragment>
          <ExpansionPanel>
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography component={"div"}>
                {t("Previous Academic semester")}
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
            <Typography component={"div"} style={{width: '100%'}}> 
                {this.firstGroup(acad, gpa, NumOfSemester)}
              </Typography>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          <ExpansionPanel defaultExpanded={true}>
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography component={"div"} >
                {t("Latest Academic semester")}
              </Typography>
            </ExpansionPanelSummary>

            <ExpansionPanelDetails>
              <Typography component={"div"} style={{width: '100%'}} >                             
                {this.lastGroup(acad, gpa, NumOfSemester)}
              </Typography>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <ExpansionPanel defaultExpanded={true}>
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >              
              <Typography component={"div"}>
                {" "}
                t.('Latest Academic semester'){" "}
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>              
              <Typography component={"div"} style={{width: '100%'}}>
                {this.lastGroup(acad, gpa, NumOfSemester)}
              </Typography>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </React.Fragment>
      );
    }
  }

  firstGroup = (acad, gpa, NumOfSemester) => {
    return gpa.map((value, index) => {
      if (index !== NumOfSemester - 1) {
        let semester = value.sem;
        let year = value.yar;
        let acadRow = acad.filter((value) => {          
          return value.sem === semester && value.yar === year;
        });
        return this.eachTable(acadRow, value);
      }
      return ""
    });
  };

  lastGroup = (acad, gpa, NumOfSemester) => {
    return gpa.map((value, index) => {
      if (index === NumOfSemester - 1) {
        let semester = value.sem;
        let year = value.yar;
        let acadRow = acad.filter((value) => {
          return value.sem === semester && value.yar === year;
        });
        return this.eachTable(acadRow, value);
      }
      return ""
    });
  };

  renderHeadingRow = () => {
    return (
      <>
        <th key={`thHead-courseno`} className="text-align-center">
          {this.props.t("Course No")}
        </th>
        <th key={`thHead-section`} className="text-align-center">
          {this.props.t("Section")}
        </th>
        <th key={`thHead-coursetitle`} className="text-align-center">
          {this.props.t("Course Title")}
        </th>
        <th key={`thHead-credit`} className="text-align-center">
          {this.props.t("Credit")}
        </th>
        <th key={`thHead-grade`} className="text-align-center">
          {this.props.t("Grade")}
        </th>
      </>
    );
  };
  
  renderRow = (rows, rowIndex) => {
    return (
      <tr key={`row-${rowIndex}`}>
        <td
          key={`row-${rowIndex}-${rows.crs}`}
          className="text-align-center"
        >          
          {rows.crs}
        </td>
        <td
          key={`row-${rowIndex}-${rows.crs}-${rows.lec}-${rows.lab}`}
          className="text-align-center"
        >          
          {rows.lec}-{rows.lab}
        </td>
        <td key={`row-${rowIndex}-${rows.tle}`}>          
          {rows.tle}
        </td>
        <td          
          key={`row-${rowIndex}-${rows.crs}-${rows.crd}`}
          className="text-align-center"
        >
          {rows.crd}
        </td>
        <td          
          key={`row-${rowIndex}-${rows.crs}-${rows.grd}`}
          className="text-align-center"
        >          
          {rows.grd}
        </td>
      </tr>
    );
  };

  eachTable = (rowAcad, rowGpa) => {
    const theadMarkup = (      
      <tr key="heading">{this.renderHeadingRow()}</tr>
    );

    return (            
      <div key={rowAcad[0].sem + rowAcad[0].yar}  style={{marginTop: '25px'}}>
        <p style={{textAlign: 'center', marginBottom: '8px'}}>
          {rowAcad[0].yly === "0"
            ? this.props.t("Acacemic Semester Year") +
              " : " +
              rowAcad[0].sem +
              "-" +
              rowAcad[0].yar
            : this.props.t("Acacemic Year") + " : " + rowAcad[0].yar}
        </p>        
        <div className="div-overflow-x">
          <table>
            <thead>{theadMarkup}</thead>
            <tbody>
              {rowAcad.map((value, index) => {
                return this.renderRow(value, index);
              })}
            </tbody>
            <tfoot>
              <tr>
                <th className="text-align-center font-bold">
                  {this.props.t("Summary")}
                </th>
                <th className="text-align-center">
                  {this.props.t("Credit All")}
                </th>
                <th className="text-align-center">
                  {this.props.t("Credit Earn")}
                </th>
                <th colSpan="2" className="text-align-center">
                  {this.props.t("GPA")}
                </th>
              </tr>
              <tr>
                <th>{this.props.t("Semester")}</th>
                <td className="text-align-center">{rowGpa.oca}</td>
                <td className="text-align-center">{rowGpa.oce}</td>
                <td colSpan="2" className="text-align-center">
                  {rowGpa.ogpa}
                </td>
              </tr>
              <tr>
                <th>{this.props.t("Cumulative")}</th>
                <td className="text-align-center">{rowGpa.acrd}</td>
                <td className="text-align-center">{rowGpa.ecrd}</td>
                <td colSpan="2" className="text-align-center">
                  {rowGpa.gpa}
                </td>
              </tr>
            </tfoot>
          </table>        
        </div>
      </div>
    );
  };
}

export default withTranslation()(AcademicResultTable);